import { h } from "preact";
import { vpDate, } from "./DateSubmitted.css";
import { fontVariant } from "../../styles/index.css";
import { getMDYFormattedDate, getTextFormattedDate } from "../../utils";
var DateSubmitted = function (_a) {
    var dateSubmitted = _a.dateSubmitted, styles = _a.styles, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.inTextFormat, inTextFormat = _c === void 0 ? false : _c;
    var dateStyles = {
        color: styles === null || styles === void 0 ? void 0 : styles.dateFontColor,
        fontSize: styles === null || styles === void 0 ? void 0 : styles.dateFontSize
    };
    var dateFont = (styles === null || styles === void 0 ? void 0 : styles.dateFont) || '';
    var formattedDate = inTextFormat
        ? getTextFormattedDate(dateSubmitted)
        : getMDYFormattedDate(dateSubmitted);
    if (!styles.showSubmissionDate) {
        return null;
    }
    return (h("p", { style: dateStyles, className: (fontVariant === null || fontVariant === void 0 ? void 0 : fontVariant[dateFont]) + " " + vpDate + " " + className }, formattedDate));
};
export default DateSubmitted;
